import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Autoridades.css";
import {
  FaUserTie,
  FaUser,
  FaEnvelope,
  FaSitemap,
} from "react-icons/fa"; 

// fOTOS LOCALES
import moises from "../assets/nosotros/autoridades/moises.jpg";
import cardenal from "../assets/nosotros/autoridades/cardenal.jpg";
import patricia from "../assets/nosotros/autoridades/patricia.jpg";
import maria from "../assets/nosotros/autoridades/maria.jpg";
import cesar from "../assets/nosotros/autoridades/cesar.jpg";
import yolanda from "../assets/nosotros/autoridades/yolanda.jpg";

const Autoridades = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const autoridades = [
    {
      frase:
        "Listos para responder a los nuevos retos, exigencias y competencias del mercado laboral.",
      nombre: "Wildor Porfirio Javier Villafuerte",
      cargo: "Director General",
      correo: "Wildor.Javier@iestpjva.edu.pe",
        
    },
    {
      frase:
        "Adaptándonos a los avances del mundo contemporáneo, tanto en la ciencia como en la tecnología.",
      nombre: "Patricia Janet Benites Yglesias",
      cargo: "Jefe de Unidad Académica",
      correo: "Patricia.Benites@iestpjva.edu.pe",
      foto: patricia,
    },
    {
      frase:
        "Una buena gestión consiste en mostrar a gente promedio cómo hacer el trabajo de gente superior.",
      nombre: "Cardenal Ipurre Contreras",
      cargo: "Jefe del Área de Administración",
      correo: "Cardenal.Ipurre@iestpjva.edu.pe",
      foto: cardenal,
    },
    {
      frase:
        "Detrás de una buena gestión hay un equipo que se esfuerza por dar lo mejor cada día.",
      nombre: "Por designar",
      cargo: "Secretario Académico",
      correo: "@iestpjva.edu.pe",
      
    },
    {
      frase:
        "El camino hacia el éxito está lleno de fracasos, pero solo aquellos que se atreven a continuar lo alcanzan.",
      nombre: "Moises Vargas Soto",
      cargo: "Jefa de Unidad de Bienestar y Empleabilidad",
      correo: "Moises.Vargas@iestpjva.edu.pe",
      foto: moises,
    },
    {
      frase:
        "Si tus acciones inspiran a otros a soñar más, aprender más, hacer más y convertirse en algo como un líder.",
      nombre: "Por designar",
      cargo: "Jefe de Unidad de Formación Continua",
      correo: "@iestpjva.edu.pe",
      
    },
    {
      frase:
        "Cualquier cosa que la mente humana pueda concebir y creer, lo puede conseguir y nunca tener miedo.",
      nombre: "Por designar",
      cargo: "Jefe de Unidad de Investigación",
      correo: "@iestpjva.edu.pe",
      
    },
  ];

  const coordinadores = [
    {
      frase:
        "La innovación y la adaptación son claves para el éxito institucional, tanto en la ciencia como en la tecnología.",
      nombre: "Por designar",
      cargo:
        "Coord. de Área Académica de Arquitectura de plataformas y STI",
      correo: "@iestpjva.edu.pe",
      
    },
    {
      frase:
        "Una buena Gestión de tu Contabilidad te permitirá tomar decisiones nuevas para hacer crecer tu negocio.",
      nombre: "Maria Cristina Maguiña Mallma",
      cargo: "Coord. de Área Académica de Contabilidad",
      correo: "Maria.maguiña@iestpjva.edu.pe",
      foto: maria,
    },
    {
      frase:
        "La Enfermería es una profesión noble y valiosa, nunca subestimes el valor de tu papel como cuidador/a de la salud.",
      nombre: "Por designar",
      cargo: "Coord. de Área Académica de Enfermería Técnica",
      correo: "@iestpjva.edu.pe",
      
    },
    {
      frase:
        "Si buscas un servicio de calidad y confianza, nuestro taller mecánico es tu mejor elección.",
      nombre: "Cesar Augusto Curampa de la Cruz",
      cargo: "Coord. de Área Académica de Mecatrónica Automotriz",
      correo: "Cesar.curampa@iestpjva.edu.pe",
      foto: cesar,
    },
    {
      frase:
        "Adaptándonos a los avances del mundo contemporáneo, tanto en la ciencia como en la tecnología.",
      nombre: "Yolanda Suarez Diaz",
      cargo: "Coord. de Área Académica en Técnica en Farmacia",
      correo: "Yolanda.suarez@iestpjva.edu.pe",
      foto: yolanda,
    },
    {
      frase:
        "No importa que te equivoques, lo importante es que puedas aprender de tus errores.",
      nombre: "Por designar",
      cargo: "Coord. del Área de Calidad",
      correo: "@iestpjva.edu.pe",
      
    },
  ];

  return (
    <section className="autoridades-page">
      <div className="autoridades-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Autoridades</h1>
          <p className="lead">
            Comprometidos con el liderazgo, la innovación y la excelencia educativa.
          </p>
        </div>
      </div>

      <div className="container py-5 text-center">
        <h2 className="section-title mb-4 text-primary">
          Equipo Directivo
        </h2>

        <div className="row g-4 justify-content-center">
          {autoridades.map((a, i) => (
            <div
              className="col-md-6 col-lg-4 d-flex justify-content-center"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <div className="autoridad-card">
                <img src={a.foto} alt={a.nombre} className="autoridad-foto" />
                <div className="autoridad-info text-start">
                    <p className="autoridad-frase">“{a.frase}”</p>
                    <p className="autoridad-linea">
                    <FaUserTie className="autoridad-icon" /> {a.nombre}
                    </p>
                    <p className="autoridad-linea">
                    <FaSitemap className="autoridad-icon" /> {a.cargo}
                    </p>
                    <p className="autoridad-linea">
                    <FaEnvelope className="autoridad-icon" />
                    <a href={`mailto:${a.correo}`} className="autoridad-correo">
                        {a.correo}
                    </a>
                    </p>
                </div>
                </div>

            </div>
          ))}
        </div>

        <h2 className="section-subtitle mt-5 text-primary">
          Coordinadores de Áreas
        </h2>

        <div className="row g-4 justify-content-center mt-3">
          {coordinadores.map((c, i) => (
            <div
              className="col-md-6 col-lg-4 d-flex justify-content-center"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <div className="autoridad-card">
                <img src={c.foto} alt={c.nombre} className="autoridad-foto" />
                <div className="autoridad-info text-start">
                    <p className="autoridad-frase">“{c.frase}”</p>
                    <p className="autoridad-linea">
                    <FaUser className="autoridad-icon" /> {c.nombre}
                    </p>
                    <p className="autoridad-linea">
                    <FaSitemap className="autoridad-icon" /> {c.cargo}
                    </p>
                    <p className="autoridad-linea">
                    <FaEnvelope className="autoridad-icon" />
                    <a href={`mailto:${c.correo}`} className="autoridad-correo">
                        {c.correo}
                    </a>
                    </p>
                </div>
                </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Autoridades;